import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, MissionPageContainer } from "../../common_components/Layout";
import SubHeader from "../SubHeader";
import Filter from "../../common_components/Filter";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import CompletedSessionUserCard from "./CompletedSessionUserCard";


// Api Calls
import ScheduledEventAPI from "../../../api/api_calls/ScheduledEventAPI";


function UpcomingSessions(props) {
    // So we'll 

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [loadingEvents, setLoadingEvents] = useState(true);
    const [completedEvents, setCompletedEvents] = useState([]);
    const [completedEventsCount, setCompletedEventsCount] = useState(-1);
    const [goalCount, setGoalCount] = useState(-1);
    const [timezone, setTimezone] = useState("");

    const [currentSort, setCurrentSort] = useState("Date");






    useEffect(() => {
        async function getCompletedSessionsAndStats() {
            const result = await ScheduledEventAPI.one_mission_completed_events_and_stats(missionId, navigate);

            if (result.success) {
                setCompletedEvents(result.completed_events)
                setCompletedEventsCount(result.completed_events_count)
                setGoalCount(result.goal_count)
                setTimezone(result.timezone)

                setLoadingEvents(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
        }

        getCompletedSessionsAndStats();
    }, []);

    function onChangeFilter(event) {
        setCurrentSort(event.target.value)
    }

    const completedEventsSorted = completedEvents.sort((a, b) => {
        if (currentSort === "Date") {
            return new Date(b.start_time) - new Date(a.start_time)
        } else {
            return a.first_name.localeCompare(b.first_name)
        }
    }
    )


    return (
        <>
            <SubHeader title={"Completed Sessions"} backText="Back to Project" navigateBack={() => navigate("/missions/" + missionId)} />
            <MissionPageContainer>
                <FilterAndCompletesRow completedEventsCount={completedEventsCount} goalCount={goalCount} onChangeFilter={onChangeFilter} />
                <div className="completed-sessions-cards-container">
                    {loadingEvents ? <CenteredLoadingIcon /> : completedEventsSorted.map((event, index) => {
                        return (
                            <CompletedSessionUserCard key={index} session={event} timezone={timezone} missionId={missionId} />
                        )
                    }
                    )}
                    {/* Order completed events by currentSort */}
                </div>
            </MissionPageContainer>
        </>

    )

}

function FilterAndCompletesRow(props) {
    return (
        <div className="filter-and-completes-row">
            <div className="filter-container">
                <div className="filter-text">Sort by:</div>
                <Filter options={["Date", "Name"]} defaultValue="Date" onChange={props.onChangeFilter} />
            </div>
            <div className="completed-sessions-count">
                {props.completedEventsCount} of {props.goalCount} completed
            </div>
        </div>
    )
}

export default UpcomingSessions;